export default __webpack_public_path__ + "static/media/banner2.12d7a481.png";